import type { StoreServicesFragment } from '@shared/gql/document-nodes'
import type { FC } from 'react'

import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { StoreInfoCard, StoreInfoCardItemWrapper, StoreInfoCardTitle } from './StoreInfoCard'

const StyledServiceContainer = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'row',
  columnGap: '8px',
})

const StoreService = styled(StoreInfoCardItemWrapper)({
  flex: '1 1 320px',
})

export const StoreServices: FC<{ store: StoreServicesFragment }> = ({ store }) => {
  const { t } = useTranslation()

  if (!store.services?.length) {
    return null
  }

  const servicesSortedByName = [...store.services].sort((a, b) =>
    (a.name?.default.toUpperCase() ?? '').localeCompare(b.name?.default.toUpperCase() ?? ''),
  )

  return (
    <StoreInfoCard>
      <StoreInfoCardTitle>{t('Services')}</StoreInfoCardTitle>

      <StyledServiceContainer>
        {servicesSortedByName.map((service) => (
          <StoreService key={service.code}>
            <span>{service.name?.default}</span>
          </StoreService>
        ))}
      </StyledServiceContainer>
    </StoreInfoCard>
  )
}
